module.exports = __webpack_public_path__ + "img/icon_label_science.ee39a71.svg";